import React from 'react';
import { Radio } from 'components/common';
import { useDispatch } from 'react-redux';
import { setView } from 'actions/search';
import { view as viewConstants } from './constants';
import { FiltersContainer } from './styled';
import { OrganisationSearch, ActivitySearch } from './helpers';
import { getResearcherText } from 'utils/constants';

const ResultsView = ({ hasVisualisations, loading, view }) => {
  const dispatch = useDispatch();

  const handleChangeView = view => {
    dispatch(setView(view));
  };

  let viewOptions = [
    {
      label: getResearcherText({ isPlural: true, capitalize: true }),
      value: viewConstants.researcher,
    },
    {
      label: 'Insights',
      value: viewConstants.visualisation,
      disabled: !hasVisualisations,
    },
    { label: 'Map', value: viewConstants.map },
  ];

  if (OrganisationSearch(view)) {
    viewOptions = [
      { label: 'Organisations', value: viewConstants.organisation },
      {
        label: 'Insights',
        value: viewConstants.organisationInsights,
        disabled: !hasVisualisations,
      },
      { label: 'Map', value: viewConstants.organisationMap },
    ];
  }

  if (ActivitySearch(view)) {
    viewOptions = [{ label: 'Activities', value: viewConstants.activity }];
  }

  return (
    <FiltersContainer>
      <Radio
        disabled={loading}
        value={view}
        options={viewOptions}
        optionType='button'
        onChange={handleChangeView}
        style={{ fontWeight: 'normal' }}
        size='small'
      />
    </FiltersContainer>
  );
};

export default ResultsView;
